import React, { FC, useEffect, useState } from "react";
import { Row, Col, Collapse /* , Button */, Spin } from "antd";
import MemberItems from "@pages/member-details/items";
import "./pcpClinicInformation.scss";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import { centricClientCheck, formatPhoneNumber } from "@utils/helpers";
import { cloneDeep } from "lodash";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const { Panel } = Collapse;

const PcpClinicInformations: FC<any> = (props) => {
  const dataCardId = "30";
  const isCentric = centricClientCheck();
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  useEffect(()=>{
    console.log("PcpClinicInformations.useEffect");
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
 }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  const genExtra = (id:any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>

  return (
    <>
      <Collapse accordion defaultActiveKey={1} expandIconPosition="right" bordered={false} activeKey={activeCardPanel} onChange={onCollapseChange}>
        <Panel header="Assigned PCP and Clinic Information" key="1" className="title" extra={genExtra(dataCardId)} style={{ marginBottom: "8px" }}>
          <Spin spinning={props.loading} indicator={<HealthemSpinner size={50} />}>
            <Row gutter={48}>
              <Col span={12}>
                <MemberItems left={12} right={12} name="Name" value={props?.data?.pcpName} />
              </Col>
              <Col span={12}>
                <MemberItems left={12} right={12} name="Clinic Name" value={props?.data?.clinicName} />
              </Col>
              <Col span={12}>
                <MemberItems left={12} right={12} name="Specialization" value={props?.data?.pcpSpecialityDesc} />
              </Col>
              <Col span={12}>
                <MemberItems left={12} right={12} name="Timings" value={props?.data?.clinicOperatingTime} />
              </Col>
              <Col span={12}>
                <MemberItems left={12} right={12} name="Phone Number" value={formatPhoneNumber(props?.data?.pcpPhoneNum, "usFormat")} />
              </Col>
              <Col span={12}>
                <MemberItems left={12} right={12} name="Clinic Contact" value={formatPhoneNumber(props?.data?.clinicPhoneNumber, "usFormat")} />
              </Col>
              <Col span={12}>
                <MemberItems
                  left={12}
                  right={12}
                  name="Email Address"
                  value={
                    props?.data?.pcpEmail !== "--" ? (
                      <a className="mail-to-link" href={`mailto:${props?.data?.pcpEmail}`}>
                        {props?.data?.pcpEmail}
                      </a>
                    ) : (
                      props?.data?.pcpEmail
                    )
                  }
                />
              </Col>
              <Col span={12}>
                <MemberItems
                  left={12}
                  right={12}
                  name="Email Address"
                  value={
                    props?.data?.clinicEmail !== "--" ? (
                      <a className="mail-to-link" href={`mailto:${props?.data?.clinicEmail}`}>
                        {props?.data?.clinicEmail}
                      </a>
                    ) : (
                      props?.data?.clinicEmail
                    )
                  }
                />
              </Col>
              <Col span={12}>
                <MemberItems
                  left={12}
                  right={12}
                  name="Assigned PCP Address"
                  value={props?.data?.pcpAddress?.split("$|")?.map((address: any) => {
                    return <div>{address}</div>;
                  })}
                />
              </Col>
              <Col span={12}>
                <MemberItems left={12} right={12} name="Clinic Address" value={props?.data?.clinicAddress} />
              </Col>
              <Col span={12}></Col>
              {isCentric && (
                <Col span={12}>
                  <MemberItems left={12} right={12} name="Clinic Group" value={props?.data?.clinicGroup} />
                </Col>
              )}
            </Row>

            {/* commented it for temporary basis for bug Id: 3811 -- Author @TaniaSharma */}

            {/* <Row>
            <Col span={18}></Col>
            {props?.data?.clinicAddress !== "--" && !isEmpty(props?.data?.clinicAddress) && (
              <Col span={6}>
                <div>
                  <Button
                    type="text"
                    shape="circle"
                    size={"small"}
                    className="map-pointer"
                    icon={<i className="icon icon-plus-circle" />}
                  >
                    View in map
                  </Button>
                </div>
              </Col>
            )}
          </Row> */}
          </Spin>
        </Panel>
      </Collapse>
    </>
  );
};

export default PcpClinicInformations;
